<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-md-8 offset-md-2 no-gutters">
          <div class="d-flex callout mb-4">
            <div class="flex-grow-1">
              Current balance:
            </div>
            <div>
              {{ user.referral_balance | currency }}
            </div>
          </div>
          <div v-if="user.referral_url">
            <h5 class="medium text-center">Referral link</h5>
            <p>Share your unique link with friends or colleagues, and you will both get $500 towards your project.</p>
            <p class="selectable">
              {{ user.referral_url }}
            </p>
          </div>
          <p>
            <hr class="space space-xs">
            <h5 class="medium mb-4">My referrals</h5>
            <div v-if="referrals && referrals.length">
              <div
                v-for="referral in referrals"
                :key="referral.id"
                class="d-flex"
              >
                <div>
                  <div class="img-round">
                    <img v-if="referral.picture" :src="referral.picture">
                    <div class="placeholder" v-else>
                      
                    </div>
                  </div>
                </div>
                <div class="flex-grow-1 pl-2">
                  <h6 class="medium mb-0">{{ referral.first_name }} {{ referral.last_name }}</h6>
                  <p class="small muted">Joined {{ referral.created | moment("D MMMM") }}</p>
                </div>
                <div class="text-primary regular">
                  {{ referral.referral_bonus | currency }}
                </div>
              </div>
            </div>
            <p v-else class="small muted">
              People you refer to Resolute will appear here.
            </p>
          </p>
        </div>
      </div>
    </div>
    <hr class="divider">
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'refer',
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      referrals: state => state.auth.referrals
    })
  },
  mounted () {
    window.scrollTo(0, 0)
    this.$store.dispatch('LOAD_REFERRALS')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
